import axios from "axios"
import { jwtDecode } from "jwt-decode"
import { dir } from "../config/directory"
import { urlApi } from '../config/urlbase'

const userProperties = ['id','nama','telp','email','tgl_biodata']

export const refreshTokenAction = async (token, navigate = () => {}) => {
    try {
        if (!token) throw new Error("Token tidak tersedia")

        const decoded = jwtDecode(token)
        const isExpired = decoded.exp * 1000 <= Date.now()

        if (isExpired) {
            localStorage.removeItem("token")
            navigate(`${dir()}/login`)
            return null
        }

        const postData = {}
        userProperties.forEach(key => {
            postData[key] = decoded[key] || ''
        })

        const response = await axios.post(`${urlApi()}refresh_token`, postData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
            },
        })

        const newToken = response.data?.token || response.data
        if (newToken) {
            localStorage.setItem("token", newToken)
            return newToken
        } else {
            throw new Error("Token refresh gagal")
        }
    } catch (error) {
        if (error.message !== "Request aborted") {
            localStorage.removeItem("token")
            navigate(`${dir()}/login`)
        }
        return null
    }
}
